module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAEWSURBVCiRldChTsNQFMbx/2mb3okZmgW5B9iGR1RMYHAkVIxkewaQnbuOCcR4BgQhoQE35MQeAXgIQlCI3qZbMV1JyN1ajjz58jtfjgD4/WmEy3kWqAlLnfOfGWrP/zJ3rEmyt+tH8fvTSBzuAQ94Nms14V1/N8J6uq1c8wScAHmx4cLBJSoxgDPlpAt6ut0Ic9JFiQF4uEROFqgxhSRVUCSsRbeYSFjtCkmyQI0dljo3HX/UGLVghfBgOv6Ipc6lCg61pz7TG0Quf68WK7NpnVY/tTYrbs3r7Krq8reAGsRzKwrUYVZwF7p9xT4MwLWB64/Vi3cYHiByXEJdRLp12E7QijbA9oJWtAZrPGoQz1tH8axJ9gcavYV9+00cHAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/shopping/Vector 172.png
// module id = iEZS
// module chunks = 8